import { getUserFromStorage } from "../actions/sharedActions";

const _initUser = getUserFromStorage();

const initState = {
    userName: _initUser?.userName ?? '',
    fullName: _initUser?.fullName ?? '',
    tellerName: _initUser?.tellerName ?? '',
    verifyOTP: _initUser?.verifyOTP ?? 0,
    token: _initUser?.token ?? '',
    tradingAccount: _initUser?.tradingAccount ?? [],
};

// updateTime: (new Date().getTime()),
// userName: response.data.UserLogin.UserName,
// fullName: response.data.UserLogin.FullName,
// tellerName: response.data.UserLogin.TellerName,
// verifyOTP: response.data.UserLogin.VerifyOTP,
// token: ticket,
// tradingAccount: response.data.lsTradingUserInfo,

export const userReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case "SetUser":
            return {
                ...state,
                userName: payload.userName,
                fullName: payload.fullName,
                tellerName: payload.tellerName,
                verifyOTP: payload.verifyOTP,
                token: payload.token,
                tradingAccount: payload.tradingAccount,
            }
        case "ClearUser":
            return {
                ...state,
                userName: '',
                fullName: '',
                tellerName: '',
                verifyOTP: 0,
                token: '',
                tradingAccount: [],
            }
        default:
            return state;
    }
};